import {
    createStore,
    combineReducers,
    compose,
    applyMiddleware
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import firebaseMiddleware from './middlewares/FirebaseMiddleware';

import {CommonActions,CommonReducer,CommonTypes} from './reducers/Common';
import {ConfigActions,ConfigReducer,ConfigTypes} from './reducers/Config';
import { UserActions, UserReducer, UserTypes } from './reducers/User';
import { profileActions, profileReducer, profileTypes } from './reducers/Profiles';
import { plansActions, plansReducer, plansTypes } from './reducers/Plans';
import { CourseActions, CourseReducer, CourseTypes } from "./reducers/Course";
import { StoriesActions, StoriesReducer, StoriesTypes } from "./reducers/Stories";
import { RewardsActions, RewardsReducer, RewardsTypes } from "./reducers/Rewards";
import { AvatarActions, AvatarReducer, AvatarTypes } from "./reducers/Avatars";
import { FirebaseActions, FirebaseTypes } from './reducers/Firebase';

import rootSaga from './sagas';

const actions={
    common: CommonActions,
    config:ConfigActions,
    user: UserActions,
    profile: profileActions,
    plans: plansActions,
    course: CourseActions,
    stories: StoriesActions,
    firebase: FirebaseActions,
    rewards: RewardsActions,
    avatars: AvatarActions
}
const types={
    common: CommonTypes,
    config:ConfigTypes,
    user: UserTypes,
    profile: profileTypes,
    plans: plansTypes,
    course:CourseTypes,
    stories: StoriesTypes,
    firebase: FirebaseTypes,
    rewards: RewardsTypes,
    avatars: AvatarTypes
}

const RootReducer=combineReducers({
    common: CommonReducer,
    config:ConfigReducer,
    user: UserReducer,
    profile: profileReducer,
    plans: plansReducer,
    course: CourseReducer,
    stories: StoriesReducer,
    rewards: RewardsReducer,
    avatars: AvatarReducer
});

const sagaMiddleware=createSagaMiddleware();
const middlewares=[ sagaMiddleware, firebaseMiddleware ];

const composeEnhancer=process.env.NODE_ENV==='production'?compose:(window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||compose);

const store=composeEnhancer(
    applyMiddleware(...middlewares)
    )(createStore)(RootReducer)

sagaMiddleware.run(rootSaga);

export default store;

export {actions,types};
